<template>
    <div>
        <v-container fill-height
                     fluid
                     grid-list-xl>
            <Loader :loading="loading"/>


            <v-layout v-if="products.length" justify-center wrap>
                <v-flex md12>


                    <download-excel
                            v-if="products_export.length"
                            :data="products_export"
                            :fields="json_fields"
                    >
                        <v-btn color="info"
                               class="p-0 mb-5 mr-4"
                               text>
                            Экспорт участников
                        </v-btn>
                    </download-excel>

                    <v-data-table :headers="headers"
                                  :items="products"
                                  hide-actions

                    >


                        <template slot="headerCell"
                                  slot-scope="{ header }">
              <span class="subheading font-weight-light text-success text--darken-3"
                    v-text="header.text"/>
                        </template>


                        <template slot="items" slot-scope="{ item }">

                            <td class="text-xs-left">
                                <img v-if="item.product && item.product.images.length" width="90"
                                     :src="item.product.images[0].image_medium" alt="">
                            </td>


                            <td class="text-xs-left">
                                <span v-if="item.client">
                                        {{item.client.first_name}}
                                        {{item.client.last_name}}
                                        <div>
                                          <b> {{item.client.phone_number}}</b>
                                        </div>
                                    </span>
                            </td>

                            <td class="text-xs-left">
                                <b>{{ item.serial_number }}</b>
                            </td>

                            <td class="text-xs-left">
                                <b v-if="item.product && item.product.vendor_code">
                                    {{ item.product.vendor_code }}
                                </b>
                            </td>
                            <td class="text-xs-left">
                                <b v-if="item.product && item.product.title">
                                    {{ item.product.title }}
                                </b>
                            </td>
                        </template>
                    </v-data-table>


                </v-flex>
            </v-layout>
        </v-container>


    </div>
</template>

<script>


    import Loader from "../../helper/Loader";

    export default {
        data: () => ({
            products: [],
            json_fields: {
                'Серийный номер': 'serial_number',
                'Секретный код': 'code_client',
                'Имя': 'first_name',
                'Фамилия': 'last_name',
                'Артикул': 'vendor_code',
                'Наименование товара': 'product_title',
                'Номер телефона': {
                    field: 'phone_number',
                    callback: (value) => {
                        return `Номер: ${value}`;
                    }
                },
                'Дата активации товара': 'created_at',
            },
            loading: true,
            headers: [
                {
                    sortable: false,
                    text: 'Изображение',
                    value: 'id'
                }, {
                    sortable: false,
                    text: 'Клиент',
                    value: 'id'
                }, {
                    sortable: false,
                    text: 'Серийный номер',
                    value: 'id'
                },
                , {
                    sortable: false,
                    text: 'Артикул',
                    value: 'dealer.name'
                },
                {
                    sortable: false,
                    text: 'Наименование',
                    value: 'dealer.name'
                }

            ],

        }),
        components: {Loader},
        methods: {
            getProducts() {
                axios.get('admin/raffles/card/activations/' + this.raffle_id).then(response => {
                    this.products = response.data.products;


                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 400);

                })
            },
        },
        computed: {

            raffle_id: {
                get() {
                    return this.raffleID;
                },
                set(val) {

                }
            },
            products_export: {
                get() {
                    let data = [];

                    if (this.products.length) {
                        for (let i = 0; i < this.products.length; i++) {
                            let phone_number = String(this.products[i].client.phone_number);
                            let first_name = String(this.products[i].client.first_name);
                            let code_client = String(this.products[i].code_client);
                            let last_name = String(this.products[i].client.last_name);
                            let created_at = String(this.products[i].client.pivot.created_at);
                            let serial_number = String(this.products[i].serial_number);
                            let product_title = String(this.products[i].product.title);
                            let vendor_code = String(this.products[i].product.vendor_code);

                            data.push(
                                {
                                    serial_number: serial_number,
                                    code_client: code_client,
                                    vendor_code: vendor_code,
                                    product_title: product_title,
                                    phone_number: phone_number,
                                    first_name: first_name,
                                    last_name: last_name,
                                    created_at: created_at,
                                }
                            );

                        }
                    }
                    return data;
                }
            }

        },
        props: ['raffleID'],
        mounted() {
            this.getProducts();
        }
    }
</script>
